export const BASE_API_SCHEDULE_PATH = 'virtualevents/schedule'
